import PortfolioConfigData from "config/portfolio-config.json";
import React from "react";
import PortfolioTablePie from "../../single/components/portfolio-table-pie/PortfolioTablePie";
import FinecoFullBarChart from "../../single/components/fineco-fullbar-chart/FinecoFullBarChart";
import PortfolioCompareTableDelta from "../../compare/components/PortfolioCompareTableDelta";

type SectionChildrenProps = { reportData: any; reportData2?: any };
const ScomposizionePortafoglioContainer: React.FC<SectionChildrenProps> = ({
  reportData,
  reportData2,
}) => {
  if (!reportData) {
    return <></>;
  }

  return (
    <>
      {!reportData2 && (
        <div style={{ marginLeft: 5, marginBottom: 20, marginTop: 16 }}>
          {/* macro assets */}

          {/* 
      *********
      DISTRUBUZIONE PER MACRO ASSET CLASS
      *********
       */}
          <PortfolioTablePie
            subSection={true}
            dataItem={{
              data: reportData.scomposizione_portafoglio
                .distribuzione_macro_asset_class,
              configData:
                PortfolioConfigData.scomposizione_portafoglio.data
                  .distribuzione_macro_asset_class,
            }}
          />
          {/* 
      *********
      DISTRUBUZIONE PER AREE GEOGRAFICHE
      *********
       */}
          <div style={{ marginTop: 16 }}></div>
          <PortfolioTablePie
            subSection={true}
            dataItem={{
              data: reportData.scomposizione_portafoglio
                .distribuzione_geografica,
              configData:
                PortfolioConfigData.scomposizione_portafoglio.data
                  .distribuzione_geografica,
            }}
          />

          {/* 
      *********
      DISTRUBUZIONE PER VALUTA
      *********
       */}
          <div style={{ marginTop: 16 }}></div>
          <FinecoFullBarChart
            data={reportData.scomposizione_portafoglio.distribuzione_valuta}
            title={
              PortfolioConfigData.scomposizione_portafoglio.data
                .distribuzione_valuta.label
            }
          />

          {/* 
      *********
      DISTRUBUZIONE PER SETTORE - FOCUS ASSET AZIONARIO
      *********
       */}
          <div style={{ marginTop: 16 }}></div>
          <FinecoFullBarChart
            data={reportData.focus_asset_azionario.distribuzione_settore}
            title={
              PortfolioConfigData.focus_asset_azionario.data
                .distribuzione_settore.label
            }
          />

          {/* 
      *********
      TIPO BOND - FOCUS ASSET OBBLIGAZIONARIO
      *********
       */}
          <div style={{ marginTop: 16 }}></div>
          <PortfolioTablePie
            subSection={true}
            dataItem={{
              data: reportData.focus_asset_obbligazionario.tipo_bond,
              configData:
                PortfolioConfigData.focus_asset_obbligazionario.data.tipo_bond,
            }}
          />

          {/* 
      *********
      DURATION - FOCUS ASSET OBBLIGAZIONARIO
      *********
       */}
          <div style={{ marginTop: 16 }}></div>
          <PortfolioTablePie
            subSection={true}
            dataItem={{
              data: reportData.focus_asset_obbligazionario.duration,
              configData:
                PortfolioConfigData.focus_asset_obbligazionario.data.duration,
            }}
          />

          {/* 
      *********
      RENDIMENTO A SCADENZA - FOCUS ASSET OBBLIGAZIONARIO
      *********
       */}
          <div style={{ marginTop: 16 }}></div>
          <PortfolioTablePie
            subSection={true}
            dataItem={{
              data: reportData.focus_asset_obbligazionario.rendimento_scadenza,
              configData:
                PortfolioConfigData.focus_asset_obbligazionario.data
                  .rendimento_scadenza,
            }}
          />

          {/* 
      *********
      QUALITA DEL DEBITO - FOCUS ASSET OBBLIGAZIONARIO
      *********
       */}
          <div style={{ marginTop: 16 }}></div>
          <FinecoFullBarChart
            data={reportData.focus_asset_obbligazionario.qualita_debito}
            title={
              PortfolioConfigData.focus_asset_obbligazionario.data
                .qualita_debito.label
            }
            section_label="Investment grade"
            section_line_after="BBB"
          />
        </div>
      )}
      {reportData2 && (
        <div style={{ marginLeft: 5, marginBottom: 10, marginTop: 16 }}>
          {/* macro assets */}
          {/* 
      *********
      DISTRUBUZIONE PER MACRO ASSET CLASS
      *********
       */}
          <PortfolioCompareTableDelta
            titleDelta="Delta distribuzione per macro asset class (Portfolio 2 vs Portfolio 1)"
            subSection={true}
            dataItem={{
              data: reportData.scomposizione_portafoglio
                .distribuzione_macro_asset_class,
              configData:
                PortfolioConfigData.scomposizione_portafoglio.data
                  .distribuzione_macro_asset_class,
            }}
            dataItem2={{
              data: reportData2.scomposizione_portafoglio
                .distribuzione_macro_asset_class,
              configData:
                PortfolioConfigData.scomposizione_portafoglio.data
                  .distribuzione_macro_asset_class,
            }}
          />
          {/* <PortfolioTablePie
            subSection={true}
            dataItem={{
              data: reportData.scomposizione_portafoglio
                .distribuzione_macro_asset_class,
              configData:
                PortfolioConfigData.scomposizione_portafoglio.data
                  .distribuzione_macro_asset_class,
            }}
          /> */}
          {/* 
      *********
      DISTRUBUZIONE PER AREE GEOGRAFICHE
      *********
       */}
          <div style={{ marginTop: 16 }}></div>
          <PortfolioCompareTableDelta
            titleDelta="Delta distribuzione per aree geografiche (Portfolio 2 vs Portfolio 1)"
            subSection={true}
            dataItem={{
              data: reportData.scomposizione_portafoglio
                .distribuzione_geografica,
              configData:
                PortfolioConfigData.scomposizione_portafoglio.data
                  .distribuzione_geografica,
            }}
            dataItem2={{
              data: reportData2.scomposizione_portafoglio
                .distribuzione_geografica,
              configData:
                PortfolioConfigData.scomposizione_portafoglio.data
                  .distribuzione_geografica,
            }}
          />
          {/* <PortfolioTablePie
            subSection={true}
            dataItem={{
              data: reportData.scomposizione_portafoglio
                .distribuzione_geografica,
              configData:
                PortfolioConfigData.scomposizione_portafoglio.data
                  .distribuzione_geografica,
            }}
          /> */}

          {/* 
      *********
      DISTRUBUZIONE PER VALUTA
      *********
       */}
          <div className="force-page-break"></div>
          <div style={{ marginTop: 16 }}></div>
          <PortfolioCompareTableDelta
            titleDelta="Delta distribuzione per valuta (Portfolio 2 vs Portfolio 1)"
            subSection={true}
            dataItem={{
              data: reportData.scomposizione_portafoglio.distribuzione_valuta,
              configData:
                PortfolioConfigData.scomposizione_portafoglio.data
                  .distribuzione_valuta,
            }}
            dataItem2={{
              data: reportData2.scomposizione_portafoglio.distribuzione_valuta,
              configData:
                PortfolioConfigData.scomposizione_portafoglio.data
                  .distribuzione_valuta,
            }}
          />
          {/* <FinecoFullBarChart
            data={reportData.scomposizione_portafoglio.distribuzione_valuta}
            title={
              PortfolioConfigData.scomposizione_portafoglio.data
                .distribuzione_valuta.label
            }
          /> */}

          {/* 
      *********
      DISTRUBUZIONE PER SETTORE - FOCUS ASSET AZIONARIO
      *********
       */}
          <div style={{ marginTop: 16 }}></div>
          <PortfolioCompareTableDelta
            titleDelta="Delta distribuzione per settore (Portfolio 2 vs Portfolio 1)"
            subSection={true}
            dataItem={{
              data: reportData.focus_asset_azionario.distribuzione_settore,
              configData:
                PortfolioConfigData.focus_asset_azionario.data
                  .distribuzione_settore,
            }}
            dataItem2={{
              data: reportData2.focus_asset_azionario.distribuzione_settore,
              configData:
                PortfolioConfigData.focus_asset_azionario.data
                  .distribuzione_settore,
            }}
          />
          {/* <FinecoFullBarChart
            data={reportData.focus_asset_azionario.distribuzione_settore}
            title={
              PortfolioConfigData.focus_asset_azionario.data
                .distribuzione_settore.label
            }
          /> */}

          {/* 
      *********
      TIPO BOND - FOCUS ASSET OBBLIGAZIONARIO
      *********
       */}
          <div className="force-page-break"></div>
          <div style={{ marginTop: 16 }}></div>
          <PortfolioCompareTableDelta
            titleDelta="Delta tipo bond - Focus asset obbligazionario (Portfolio 2 vs Portfolio 1)"
            subSection={true}
            dataItem={{
              data: reportData.focus_asset_obbligazionario.tipo_bond,
              configData:
                PortfolioConfigData.focus_asset_obbligazionario.data.tipo_bond,
            }}
            dataItem2={{
              data: reportData2.focus_asset_obbligazionario.tipo_bond,
              configData:
                PortfolioConfigData.focus_asset_obbligazionario.data.tipo_bond,
            }}
          />
          {/* <PortfolioTablePie
            subSection={true}
            dataItem={{
              data: reportData.focus_asset_obbligazionario.tipo_bond,
              configData:
                PortfolioConfigData.focus_asset_obbligazionario.data.tipo_bond,
            }}
          /> */}

          {/* 
      *********
      DURATION - FOCUS ASSET OBBLIGAZIONARIO
      *********
       */}
          <div style={{ marginTop: 16 }}></div>
          <PortfolioCompareTableDelta
            titleDelta="Delta focus asset obbligazionario (Portfolio 2 vs Portfolio 1)"
            subSection={true}
            dataItem={{
              data: reportData.focus_asset_obbligazionario.duration,
              configData:
                PortfolioConfigData.focus_asset_obbligazionario.data.duration,
            }}
            dataItem2={{
              data: reportData2.focus_asset_obbligazionario.duration,
              configData:
                PortfolioConfigData.focus_asset_obbligazionario.data.duration,
            }}
          />

          {/* 
      *********
      RENDIMENTO A SCADENZA - FOCUS ASSET OBBLIGAZIONARIO
      *********
       */}
          <div className="force-page-break"></div>
          <div style={{ marginTop: 16 }}></div>
          <PortfolioCompareTableDelta
            titleDelta="Delta rendimento a scadenza - Focus asset obbligazionario (Portfolio 2 vs Portfolio 1)"
            subSection={true}
            dataItem={{
              data: reportData.focus_asset_obbligazionario.rendimento_scadenza,
              configData:
                PortfolioConfigData.focus_asset_obbligazionario.data
                  .rendimento_scadenza,
            }}
            dataItem2={{
              data: reportData2.focus_asset_obbligazionario.rendimento_scadenza,
              configData:
                PortfolioConfigData.focus_asset_obbligazionario.data
                  .rendimento_scadenza,
            }}
          />
          {/* 
      *********
      QUALITA DEL DEBITO - FOCUS ASSET OBBLIGAZIONARIO
      *********
       */}
          {/* <div className="force-page-break"></div> */}
          <div style={{ marginTop: 16 }}></div>
          <PortfolioCompareTableDelta
            titleDelta="Delta qualità del debito - Focus asset obbligazionario (Portfolio 2 vs Portfolio 1)"
            subSection={true}
            dataItem={{
              data: reportData.focus_asset_obbligazionario.qualita_debito,
              configData:
                PortfolioConfigData.focus_asset_obbligazionario.data
                  .qualita_debito,
            }}
            dataItem2={{
              data: reportData2.focus_asset_obbligazionario.qualita_debito,
              configData:
                PortfolioConfigData.focus_asset_obbligazionario.data
                  .qualita_debito,
            }}
          />
        </div>
      )}
    </>
  );
};
export default React.memo(
  ScomposizionePortafoglioContainer,
  (prevProps: SectionChildrenProps, nextProps: SectionChildrenProps) => {
    // Custom comparison function
    return prevProps.reportData === nextProps.reportData;
  },
);
